export default __webpack_public_path__ + "static/media/alert.5bfdd493.mp3";